module.exports = __webpack_public_path__ + "static/media/media.06d3b7ab.svg";